export function buildWebSocketUrl(pathOrUrl: string): string {
  const raw = pathOrUrl.trim() || "/ws";

  if (raw.startsWith("ws://") || raw.startsWith("wss://")) {
    return raw;
  }

  const base =
    typeof window !== "undefined" ? window.location.origin : "http://localhost";
  const url = new URL(raw, base);
  url.protocol = url.protocol === "https:" ? "wss:" : "ws:";
  return url.toString();
}
